import React from 'react'

import ProductSelection from '../components/ProductSelection'

const ChooseProduct: React.FC<React.PropsWithChildren<unknown>> = () => <ProductSelection />

export default ChooseProduct
